import * as React from 'react';

import Icon from '@/assets/icons/icon_girls.svg';

interface GirlsProps {
  isGirls: boolean;
  width?: string;
  height?: string;
}

const GirlsIcon: React.FC<GirlsProps> = ({
  isGirls,
  width = '16px',
  height = '16px',
}) => {
  return (
    <>
      {isGirls && <img src={Icon} style={{ width, height }} alt="ガールズ" />}
    </>
  );
};

export default GirlsIcon;
